import { useMemo } from "react";
import {
  selectPeerScreenSharing,
  selectScreenShareByPeerID,
  useHMSStore,
  useVideo,
} from "@100mslive/react-sdk";
import type { ProviderScreenShareVideo } from "../types";
import { convertHMSPeerToPeer } from "./helpers";

export const useHMSScreenShareVideo = (): ProviderScreenShareVideo => {
  const hmsPeer = useHMSStore(selectPeerScreenSharing);
  const peer = useMemo(
    () => (hmsPeer ? convertHMSPeerToPeer(hmsPeer) : undefined),
    [hmsPeer],
  );
  const videoTrack = useHMSStore(selectScreenShareByPeerID(peer?.id));
  const { videoRef } = useVideo({ trackId: videoTrack?.id });

  return {
    peer,
    videoRef,
    hasVideo: !!videoTrack?.enabled,
    shouldWarnInfinityMirror: videoTrack?.displaySurface === "monitor",
  };
};
